import * as React from 'react'
import './HoursPicker.scss';

import { Checkbox, Dropdown, SelectableOption } from '@swivl-mono/ui';
import TimezonePicker from 'react-timezone';
import { CheckedState } from '@radix-ui/react-checkbox';

interface Props {
  hours: any;
  onChange: any;
  timezoneName: string;
}

export default class HoursPicker extends React.Component<Props> {
  hours: SelectableOption[] = [{ label: "12:00 AM", value: "0:00" }]
  constructor(props) {
    super(props)
    let hourMark = 0;
    let minuteMark = 15;
    while (hourMark < 24) {
      let hourString = (hourMark > 12) ? hourMark - 12 : hourMark;
      if (hourString === 0) { hourString = 12 }
      const amPm = (hourMark >= 12) ? "PM" : "AM";
      const minutesString = (minuteMark < 10) ? "0" + minuteMark : String(minuteMark);

      this.hours.push({ label: `${hourString}:${minutesString} ${amPm}`, value: `${hourMark}:${minutesString}` })

      minuteMark += 15;
      if (minuteMark > 45) {
        minuteMark = 0;
        hourMark++;
      }
    }
    this.timezoneUpdate = this.timezoneUpdate.bind(this)
  }
  timezoneUpdate(tz) {
    this.props.onChange({ target: { name: "hours.timezone", value: tz } })
  }

  renderRow(name, hours, onChange) {
    const key = name.toLowerCase();
    const handleCheckboxChange = (checked: CheckedState) => {
      const syntheticEvent = {
        target: { name: `hours.${key}.open`, value: checked }
      };

      onChange(syntheticEvent);
    }

    return <div key={name} className="hoursPickerRow">
      <div className="mr-2">
        <Checkbox
          checked={hours[key].open}
          label={name}
          name={`hours.${key}.open`}
          onCheckedChange={handleCheckboxChange}
        />
      </div>
      <Dropdown
        options={this.hours}
        name={`hours.${key}.start`}
        value={hours[key].start}
        onChange={onChange}
      />
      <div className="text">to</div>
      <Dropdown
        options={this.hours}
        name={`hours.${key}.end`}
        value={hours[key].end}
        onChange={onChange}
      />
    </div>
  }

  render() {
    const { hours, onChange } = this.props;

    const rows = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map(name => this.renderRow(name, hours, onChange))

    return <div className="HoursPicker">
      <div className="timeZone">
        <TimezonePicker
          value={hours.timezone}
          onChange={this.timezoneUpdate}
          style={{ width: "100%" }}
          inputProps={{
            placeholder: 'Select Timezone...',
            name: this.props.timezoneName,
          }}
        />
      </div>
      {rows}
    </div>
  }
}